import {
  BadgeCheck,
  BarChart3,
  CalendarClock,
  CalendarDays,
  FileClock,
  Gavel,
  Heart,
  LayoutDashboard,
  MessageSquare,
  MessageSquareQuote,
  Search,
  Settings,
  SlidersHorizontal,
  Tags,
  Target,
  UserRound,
  Users,
  Wallet,
} from 'lucide-react'

export const PUBLIC_NAV = [
  { to: '/explore', label: 'Explore mentors' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/faq', label: 'FAQ' },
  { to: '/about', label: 'About' },
]

export const PORTALS = {
  mentee: {
    label: 'Mentee',
    home: '/mentee',
    nav: [
      { to: '/mentee', label: 'Dashboard', icon: LayoutDashboard, end: true },
      { to: '/mentee/profile', label: 'Profile', icon: UserRound },
      { to: '/explore', label: 'Find mentors', icon: Search },
      { to: '/mentee/bookings', label: 'Bookings', icon: CalendarDays },
      { to: '/mentee/goals', label: 'Goals & progress', icon: Target },
      { to: '/mentee/messages', label: 'Messages', icon: MessageSquare },
      { to: '/mentee/favourites', label: 'Saved mentors', icon: Heart },
      { to: '/mentee/settings', label: 'Settings', icon: Settings },
    ],
  },
  mentor: {
    label: 'Mentor',
    home: '/mentor',
    nav: [
      { to: '/mentor', label: 'Dashboard', icon: LayoutDashboard, end: true },
      { to: '/mentor/profile', label: 'Profile', icon: UserRound },
      { to: '/mentor/availability', label: 'Availability', icon: CalendarClock },
      { to: '/mentor/bookings', label: 'Bookings', icon: CalendarDays },
      { to: '/mentor/earnings', label: 'Earnings', icon: Wallet },
      { to: '/mentor/messages', label: 'Messages', icon: MessageSquare },
      { to: '/mentor/settings', label: 'Settings', icon: Settings },
    ],
  },
  admin: {
    label: 'Admin',
    home: '/admin',
    nav: [
      { to: '/admin', label: 'Overview', icon: BarChart3, end: true },
      { to: '/admin/verification', label: 'Verification', icon: BadgeCheck },
      { to: '/admin/users', label: 'Users', icon: Users },
      { to: '/admin/bookings', label: 'Bookings', icon: CalendarDays },
      { to: '/admin/disputes', label: 'Disputes', icon: Gavel },
      { to: '/admin/reviews', label: 'Reviews', icon: MessageSquareQuote },
      { to: '/admin/finance', label: 'Finance', icon: Wallet },
      { to: '/admin/skills', label: 'Skill taxonomy', icon: Tags },
      { to: '/admin/settings', label: 'Platform settings', icon: SlidersHorizontal },
      { to: '/admin/audit', label: 'Audit log', icon: FileClock },
      { to: '/admin/account', label: 'My account', icon: UserRound },
    ],
  },
}
